export default __webpack_public_path__ + "static/Zimbabwesreverednestcustodians-45dc9ce9ef51a1e69ec1df65de006771.jpg";